// Branding Constants
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_island-compliance/artifacts/jpvh27du_Transparent-removebg-preview.png";
export const APP_NAME = "Privacy Pulse";
export const COMPANY_NAME = "Privicy Advisory Services";
export const CONTACT_EMAIL = "info@myprivicy.com";
export const CONTACT_PHONE = "1-868-461-4572";

// Jurisdiction Data
export const JURISDICTION_FLAGS = {
  jamaica: '🇯🇲',
  barbados: '🇧🇧',
  bermuda: '🇧🇲',
  cayman: '🇰🇾',
  bahamas: '🇧🇸',
  belize: '🇧🇿',
  grenada: '🇬🇩'
};

export const JURISDICTION_NAMES = {
  jamaica: 'Jamaica',
  barbados: 'Barbados',
  bermuda: 'Bermuda',
  cayman: 'Cayman Islands',
  bahamas: 'The Bahamas',
  belize: 'Belize',
  grenada: 'Grenada'
};

// Legal Disclaimer
export const LEGAL_DISCLAIMER = `This compliance assessment tool is provided for informational and guidance purposes only. It does not constitute legal advice and should not be relied upon as such.

The results of this assessment are based solely on the information you provide and are intended to give you a general understanding of your organization's compliance posture with respect to the relevant data protection legislation.

We strongly recommend that you share the results of this assessment with a qualified legal professional or certified data protection officer who can provide advice tailored to your specific circumstances.

${COMPANY_NAME} accepts no liability for any actions taken or not taken based on the results of this assessment.`;
